import React from 'react';
import { InputLabel } from '@material-ui/core';
import { EditableQuestion } from '../../../../../types';
import { Control, Controller } from 'react-hook-form';
import { RichTextEditor } from '../../../../../../Shared/Form';
import { StyledQuestionFieldContainer } from '../styles';
import { ErrorMessage } from '../../../../../../Services/styled-components';

interface Props {
  control: Control<EditableQuestion>;
}

const ExplanationEditor = ({ control }: Props) => (
  <Controller
    control={control}
    name="description_html"
    render={({ field, formState }) => (
      <StyledQuestionFieldContainer>
        <InputLabel>Explanation</InputLabel>
        <RichTextEditor
          modules={null}
          onChange={field.onChange}
          value={field?.value}
        />
        <ErrorMessage>{formState.errors.description_html?.message}</ErrorMessage>
      </StyledQuestionFieldContainer>
    )}
  />
);

export default ExplanationEditor;
